import { EventEmitter } from '@angular/core';
import { ConditionType } from './condition-type';
import { BitConditionItemObserver } from './bit-condition-item-observer';
import { RelationConditionResult } from './relation-condition-result';
import { WordConditionItemObserver } from './word-condition-item-observer';
import { RelationType } from './relation-type';
export class ConditionItemsResultObserver {
    constructor(sourceConditionItems, variableCommunicator, variableStore) {
        this.sourceConditionItems = sourceConditionItems;
        this.variableCommunicator = variableCommunicator;
        this.variableStore = variableStore;
        this.conditionResultChanged = new EventEmitter();
        this.conditionResults = new Map();
    }
    requestData() {
        if (null == this.sourceConditionItems || !this.sourceConditionItems.length) {
            return;
        }
        const conditionItems = this.sourceConditionItems.sort(t => t.index);
        conditionItems.forEach(item => {
            switch (item.conditionType) {
                case ConditionType.Bit:
                    const bitItem = new BitConditionItemObserver(item.condition, this.variableCommunicator, this.variableStore);
                    bitItem.conditionEffectiveChanged.subscribe(itemResult => {
                        if (this.conditionResults.has(conditionItems.indexOf(item))) {
                            this.conditionResults.delete(conditionItems.indexOf(item));
                        }
                        this.conditionResults.set(conditionItems.indexOf(item), new RelationConditionResult(item.relationType, itemResult));
                        this.emitConditionResult();
                    });
                    bitItem.requestData();
                    break;
                case ConditionType.Word:
                    const wordItem = new WordConditionItemObserver(item.condition, this.variableCommunicator, this.variableStore);
                    wordItem.conditionEffectiveChanged.subscribe(itemResult => {
                        if (this.conditionResults.has(conditionItems.indexOf(item))) {
                            this.conditionResults.delete(conditionItems.indexOf(item));
                        }
                        this.conditionResults.set(conditionItems.indexOf(item), new RelationConditionResult(item.relationType, itemResult));
                        this.emitConditionResult();
                    });
                    wordItem.requestData();
                    break;
                default:
                    throw new Error(`Unknown ConditionType :${item.conditionType}`);
            }
        });
    }
    emitConditionResult() {
        let isControl = true;
        const elementStates = [];
        this.conditionResults.forEach(t => {
            // eslint-disable-next-line eqeqeq
            if (t.relationType == RelationType.None) {
                isControl = t.result.value;
                elementStates.push(t.result.state);
            }
        });
        this.conditionResults.forEach(item => {
            // eslint-disable-next-line eqeqeq
            if (item.relationType == RelationType.Or) {
                isControl = isControl || item.result.value;
                elementStates.push(item.result.state);
                // eslint-disable-next-line eqeqeq
            }
            else if (item.relationType == RelationType.And) {
                isControl = isControl && item.result.value;
                elementStates.push(item.result.state);
            }
        });
        const conditionControlResult = {
            states: elementStates,
            value: isControl
        };
        this.conditionResultChanged.emit(conditionControlResult);
    }
}
